import { fetchClient } from '../axiosinterceptor';

export const getPermission = async () => {
  const { data } = await fetchClient().get('/permissions');

  return data;
}